
import { CookieManager } from "react-cookie-manager";
import "react-cookie-manager/style.css";
const CookieManagement = (props) => {
    const legal_url = process.env.REACT_APP_LEGAL_URL
    return (
        <CookieManager
            translations={{
                title: "Maintel Cookie Preferences",
                message: "We use cookies to improve your experience and help us understand how the website is used. Essential cookies are always enabled so the website can work properly.",
                buttonText: "Accept All",
                declineButtonText: "Accept Essentials",
                manageButtonText: "Manage Cookies",
                privacyPolicyText: "Privacy Policy",
                                
                // Manage consent modal
                manageTitle: "Maintel Cookie Preferences",
                manageMessage: "Manage your cookie preferences below. Essential cookies are always enabled as they are necessary for the website to function properly. Webchat is controlled by the Social / Webchat category.",

                // Essential cookies section
                manageEssentialTitle: "Essential",
                manageEssentialSubtitle: "Required for the Maintel Portal to function properly",
                manageEssentialStatus: "Status: Always enabled",
                manageEssentialStatusButtonText: "Always On",

                // Analytics cookies section
                manageAnalyticsTitle: "Analytics",
                manageAnalyticsSubtitle: "Help us understand how visitors interact with our website",

                // Social cookies section
                manageSocialTitle: "Social / Webchat",
                manageSocialSubtitle: "Enable webchat cookies so support conversations can work",

                // Status messages
                manageCookiesStatus: "Status: {{status}} on {{date}}", // Supports variables
                manageCookiesStatusConsented: "Consented",
                manageCookiesStatusDeclined: "Declined",

                // Buttons in manage modal
                manageCancelButtonText: "Cancel",
                manageSaveButtonText: "Save Preferences"
            }}
            showManageButton={true}
            cookieKey="maintel-portal-cookie"
            privacyPolicyUrl={legal_url}
            displayType="modal"
            theme="light"
            disableAutomaticBlocking={true}
            onManage={(preferences) => {
                if (preferences) {
                  console.log("Cookie preferences updated:", preferences);
                }
              }}
        >
            {props.children}
        </CookieManager>
    )
};
export default CookieManagement;